import React, { createContext, useContext, useRef } from "react";

const RefsContext = createContext(null);

export const RefsProvider = ({ children }) => {
  const captureRef = useRef(null);
  // Add future shared refs here

  return (
    <RefsContext.Provider
      value={{
        captureRef,
      }}
    >
      {children}
    </RefsContext.Provider>
  );
};

export const useRefs = () => {
  const ctx = useContext(RefsContext);
  if (!ctx) throw new Error("useRefs must be used within RefsProvider");
  return ctx;
};

export default RefsContext;
